module.exports = __webpack_public_path__ + "img/unlock-button-infiniti-hovered.5bb9c7ae.png";